import { Feature, Map } from "ol";
import LineString from "ol/geom/LineString";
import { Style, Stroke } from "ol/style";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { TooltipManager } from "./tooltip";
import { geojson } from "@lib/geojson";
import { fromLonLat } from "ol/proj";
import { Color } from "@lib/color";

export interface PolylineType {
    coordinates: geojson.Coord[];
    content: string;
    color: string;
}

export interface PolylineCornerLocations {
    start: geojson.Coord;
    finish: geojson.Coord;
    name: string;
    color?: Color;
}

export class PolylineManager {
    private readonly mapElement: Map;
    private readonly tooltip: TooltipManager;
    private vectorSource = new VectorSource();
    private vectorLayer: VectorLayer;

    constructor(mapElement: Map, tooltip: TooltipManager) {
        this.mapElement = mapElement;
        this.tooltip = tooltip;
        this.vectorLayer = new VectorLayer({ source: this.vectorSource });
        this.mapElement.addLayer(this.vectorLayer);
    }

    add(item: PolylineType) {
        const polylineFeature = new Feature({
            geometry: new LineString(item.coordinates.map((coord) => fromLonLat(coord))),
        });
        polylineFeature.set('name', item.content);
        this.renderPolyline(polylineFeature, item.color);
    }

    private renderPolyline(polylineFeature: Feature<LineString>, color: string) {
        const style = new Style({
            stroke: new Stroke({
                color: color,
                width: 2,
            }),
        });

        polylineFeature.setStyle(style);
        this.vectorSource.addFeature(polylineFeature);
    }

    clear() {
        this.vectorSource.clear();
    }
}
